module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segments"
  }, [_c('div', {
    staticClass: "ui segment"
  }, [_c('div', {
    staticClass: "ui breadcrumb"
  }, [_c('router-link', {
    staticClass: "section",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Sākums")]), _vm._v(" "), _c('span', {
    staticClass: "divider"
  }, [_vm._v("/")]), _vm._v(" "), _c('router-link', {
    staticClass: "section",
    attrs: {
      "to": {
        name: 'waiting-for-delivery'
      }
    }
  }, [_vm._v("Gaida piegādi")]), _vm._v(" "), _c('span', {
    staticClass: "divider"
  }, [_vm._v("/")]), _vm._v(" "), _c('div', {
    staticClass: "active section"
  }, [_vm._v("Apskatīt")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ui segment"
  }, [(_vm.order.warning && _vm.order.warning.indexOf('NOT-CONFIRMED;') > -1 && _vm.$route.query.approve != 'yes') ? _c('div', {
    staticClass: "ui warning icon message"
  }, [_c('i', {
    staticClass: "info circle icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n         Uzmanību!\n       ")]), _vm._v(" "), _c('p', [_vm._v("Lūdzu apstipriniet rītdienas BIOveikala Autoship pasūtījumu")]), _vm._v(" "), _c('div', {
    staticClass: "ui custom_brown button",
    class: {
      loading: _vm.showLoading
    },
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": _vm.confirmDelivery
    }
  }, [_c('div', {
    staticClass: "visible content"
  }, [_vm._v("Apstiprināt rītdienas piegādi")])])])]) : _vm._e(), _vm._v(" "), (_vm.order.confirmed && _vm.order.status >= 3) ? _c('div', {
    staticClass: "ui positive icon message"
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n         Paldies!\n       ")]), _vm._v(" "), _c('p', [_vm._v("BIOveikala Autoship pasūtījums tiks piegādāts "), _c('b', [_vm._v(_vm._s(_vm.order.delivery_date))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui form"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "two fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Adrese")]), _vm._v(" "), _c('select', {
    staticClass: "ui fluid dropdown",
    attrs: {
      "disabled": ""
    }
  }, _vm._l((_vm.address), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id,
        "selected": item.id == _vm.order.address_id ? true : false
      }
    }, [_vm._v("\n                  " + _vm._s(item.street)), (item.house_no != '') ? _c('span', [_vm._v(" ")]) : _vm._e(), _vm._v(_vm._s(item.house_no)), (item.flat_no != '') ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(item.flat_no)), (item.city_label != '') ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(item.city_label) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "two fields"
  }, [_c('div', {
    staticClass: "ui calendar field",
    attrs: {
      "id": "start_date"
    }
  }, [_c('label', [_vm._v("Piegādes datums")]), _vm._v(" "), _c('div', {
    staticClass: "ui input left icon"
  }, [_c('i', {
    staticClass: "calendar icon"
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Norādit piegādes datumu",
      "disabled": ""
    },
    domProps: {
      "value": _vm.order.delivery_date
    }
  })])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ui container"
  }, [_c('div', {
    staticClass: "ui attached segment",
    class: {
      loading: _vm.storeStatus.loading
    }
  }, [_c('div', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "ui divided items"
  }, _vm._l((_vm.order.order_items_list), function(item) {
    return _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "ui tiny image"
    }, [_c('img', {
      attrs: {
        "src": 'https://res.cloudinary.com/mwsuite/image/upload/f_auto,w_80,h_117,c_lfill/product/' + item.good_id + '.jpg'
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('a', {
      staticClass: "header"
    }, [_vm._v(_vm._s(item.goods_name))]), _vm._v(" "), _c('div', {
      staticClass: "meta"
    }), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_c('p', [_vm._v(_vm._s(item.description))])]), _vm._v(" "), _c('div', {
      staticClass: "extra"
    }, [(item.no_of_goods_return > 0) ? _c('div', {
      staticClass: "ui right floated inline fields",
      attrs: {
        "disabled": ""
      }
    }, [_c('label', [_vm._v("Atgriezīšu:   x ")]), _vm._v(" "), _c('div', {
      staticClass: "field"
    }, [_c('input', {
      staticStyle: {
        "width": "70px"
      },
      attrs: {
        "type": "text",
        "placeholder": "skaits",
        "disabled": "",
        "number": ""
      },
      domProps: {
        "value": item.no_of_goods_return
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "ui right floated inline fields"
    }, [_c('label', [_vm._v("Pasūtīšu:   x ")]), _vm._v(" "), _c('div', {
      staticClass: "field"
    }, [_c('input', {
      staticStyle: {
        "width": "70px"
      },
      attrs: {
        "type": "text",
        "placeholder": "skaits",
        "disabled": "",
        "number": ""
      },
      domProps: {
        "value": item.no_of_goods
      }
    })])])])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "ui clearing hidden divider"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "ui secondary segment"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "ui two column grid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "ui column form"
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Apmaksas veids")]), _vm._v(" "), _c('select', {
    staticClass: "ui fluid dropdown",
    attrs: {
      "disabled": ""
    }
  }, [_c('option', {
    attrs: {
      "value": "3"
    },
    domProps: {
      "selected": _vm.order.payment_type == 3
    }
  }, [_vm._v("Skaidrā saņemot preci")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    },
    domProps: {
      "selected": _vm.order.payment_type == 2
    }
  }, [_vm._v("No konta")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Komentāri")]), _vm._v(" "), _c('textarea', {
    attrs: {
      "rows": "4",
      "disabled": ""
    },
    domProps: {
      "value": _vm.order.notes
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [(_vm.order && _vm.order.id > 0) ? _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "ui list",
    staticStyle: {
      "text-align": "right",
      "margin-top": "30px"
    }
  }, [(_vm.order.bail != 0) ? _c('div', {
    staticClass: "item",
    staticStyle: {
      "color": "#E12F2E"
    },
    attrs: {
      "id": "bail",
      "data-content": "Turpiniet, ievadot piegādes datumu un pārbaudiet veikto pasūtījumu. Ņemiet vērā, ka par katru lietošanā esošo pudeli jāmaksā drošības nauda. Drošības nauda tiks atgriezta pēc tukšo pudeļu atdošanas"
    }
  }, [_vm._v("Drošības nauda: " + _vm._s(_vm.order.bail) + " €")]) : _vm._e(), _vm._v(" "), (_vm.order.delivery_amount != 0) ? _c('div', {
    staticClass: "item",
    staticStyle: {
      "color": "#E12F2E"
    },
    attrs: {
      "id": "delivery",
      "data-html": "Piegādes maksa netiks pievienota, ja pasūtīsiet produktus par vismaz 20 EUR."
    }
  }, [_vm._v("Piegāde: " + _vm._s(_vm.order.delivery_amount) + " €")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('b', [_vm._v("Kopsumma: " + _vm._s(_vm.order.total_amount_with_bail_and_vat) + " €")])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "ui right floated buttons"
  }, [_c('button', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'waiting-for-delivery'
        })
      }
    }
  }, [_vm._v("Atpakaļ")]), _vm._v(" "), _c('div', {
    staticClass: "or",
    attrs: {
      "data-text": "vai"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ui green button",
    class: {
      disabled: _vm.order.status != 3
    },
    on: {
      "click": _vm.goToEditPage
    }
  }, [_vm._v("Rediģēt")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "ui clearing hidden divider"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "ui dividing header"
  }, [_c('i', {
    staticClass: "marker icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n        Piegādes informācija\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "ui dividing header"
  }, [_c('i', {
    staticClass: "shop icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n     Preces\n   ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "ui dividing header"
  }, [_c('i', {
    staticClass: "money icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n      Kopsavilkums\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2ff1cb53!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WaitingForDeliveryViewPage.vue
// module id = 335
// module chunks = 1